import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AulaGratis } from 'src/app/models/aula-gratis';
import { DadosPlano } from 'src/app/models/dados-plano';

@Injectable({
  providedIn: 'root',
})
export class CursoService {
  constructor(private http: HttpClient) {}

  getAulaGratis() {
    return this.http.get<AulaGratis>(`${environment.baseApiUrl}/cursos/${this.getCursoTrialId()}/aula-gratis`);
  }

  getCursoTrialId() {
    const curso = JSON.parse(localStorage.getItem('cursoTrial'));
    return curso.id;
  }

  getDadosCurso(mes: number) {
    return this.http.get<DadosPlano>(`${environment.baseApiUrl}/cursos/dados?mes=${mes}`);
  }
}
